import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  static readonly tokenKey = 'n0_access_token';

  private localStorageService: LocalStorageService = inject(LocalStorageService);
  private token: string | null = null;

  constructor() {
    this.token = this.localStorageService.getItem(AuthService.tokenKey);
  }

  setToken(token: string): void {
    this.token = token;
    this.localStorageService.setItem(AuthService.tokenKey, this.token);
  }

  getToken(): string | null {
    return this.token;
  }

  removeToken(): void {
    this.token = null;
    this.localStorageService.removeItem(AuthService.tokenKey);
  }
}
